import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ListUtesService } from '../list.service';
import { TranslateService } from '@ngx-translate/core';

import  {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { UtesService } from '../utes.service';

@Component({
  selector: 'mcrit-gestio-utes-filters',
  templateUrl: 'utes-filters.component.html',
  styleUrls: ['utes-filters.component.css'],
  providers: []
})
export class UtesFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;

  constructor(public translate: TranslateService, private listUtesService: ListUtesService,private utesService: UtesService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listUtesService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listUtesService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listUtesService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters() {
    this.listUtesService.valFiltres={};

    this.filterModel = { statePendent: true };
    this.sendActiveFilters();
  }

  ngOnInit() {
    let requestedAutocompletes = [];
    this.filterModel = this.validFilters.reduce((acum, curr) => {
        curr.inputs.forEach(inputGroup => {
          switch (inputGroup.type) {
            case 'select':
              acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
              break;
            default:
            inputGroup.values.forEach(input => {
              if (input.autocomplete) { }
              acum[input.name] = (input.value ? input.value : null);
              if(input.autocomplete)requestedAutocompletes.push(input.autocomplete);
                acum[input.name] = (input.value ? input.value : null);
              });
          }
        });

      return acum;
    }, {});
    this.dataLists = requestedAutocompletes.map(id => { return { id: id, options: this.listUtesService.getAutocomplete(id) }; });

    this.sendActiveFilters();
  }
}
